export default __webpack_public_path__ + "static/media/landingImage1.e3b56197.png";